// client/docs.ts
import { html } from "lit";
function docs() {
  return html`
    <div class="urlpattern-docs">
      <h2>Übersicht</h2>
      <p>
        URLPattern ist eine moderne API zur Verarbeitung von URL-Pfaden. Diese Dokumentation erklärt die verschiedenen
        Möglichkeiten, URLs zu matchen und zu verarbeiten.
      </p>

      <h3>Grundlegende Syntax</h3>

      <h4>1. Einfache Parameter</h4>
      <p>Verwenden Sie <code>:paramName</code> um einen dynamischen Parameter zu definieren.</p>
      <pre><code>Beispiel: /user/123
'/user/:id'</code></pre>

      <h4>2. Parameter mit Typ-Constraints</h4>
      <p>Sie können den Typ eines Parameters einschränken:</p>
      <pre><code>Nur Zahlen erlaubt
'/user/:id{number}'

Nur Strings erlaubt
'/user/:name{string}'

Nur Boolean-Werte erlaubt
'/user/:active{boolean}'</code></pre>

      <h4>3. Regex-Constraints</h4>
      <p>Verwenden Sie reguläre Ausdrücke für komplexere Einschränkungen:</p>
      <pre><code>Nur Zahlen (ein oder mehr Ziffern)
'/user/:id{d+}'

Nur Kleinbuchstaben
'/user/:name{[a-z]+}'

Hexadezimal
'/user/:hash{[0-9a-f]+}'</code></pre>

      <h4>4. Optionale Segmente</h4>
      <p>Machen Sie Teile des Pfads optional mit <code>?</code>:</p>
      <pre><code>Optionaler Parameter
'/user/:id?'

Optionales Segment
'/blog/:slug?'

Optionaler Parameter mit Typ
'/user/:id{number}?'

Optionales Segment mit Wildcard
'/user/:id{/*}?'</code></pre>

      <h4>5. Gruppierung</h4>
      <p>Verwenden Sie runde Klammern für Gruppierungen:</p>
      <pre><code>Entweder profile oder settings
'/user/(profile|settings)'

Optionales gruppiertes Segment
'/user/(profile|settings)?'</code></pre>

      <h4>6. Wildcards</h4>
      <p>Verwenden Sie <code>*</code> für Wildcards:</p>
      <pre><code>Matcht alles
'/files/*'

Matcht alles inklusive Slashes
'/files/**'</code></pre>

      <h3>Komplexe Beispiele</h3>

      <h4>1. API Versioning</h4>
      <pre><code>API mit Versionsnummer und Ressource
'/api/v:version{number}/:resource{(users|posts|comments)}/:id{d+}?'</code></pre>

      <h4>2. Benutzer-Aktionen</h4>
      <pre><code>Benutzer mit ID und Aktion
'/user/:id{number}/:action{(view|edit|delete)}'</code></pre>

      <h4>3. Blog-System</h4>
      <pre><code>Blog mit optionalem Slug und Kategorie
'/blog/:category{(news|tech|life)}/:slug?'</code></pre>

      <h4>4. Optionale Wildcards</h4>
      <p>
        Der Fall <code>{/*}?</code> ist besonders nützlich, wenn Sie ein optionales Segment mit einem Wildcard
        kombinieren möchten:
      </p>
      <pre><code>Matcht /user/123 und /user/123/anything/here
'/user/:id{/*}?'

Matcht /blog und /blog/any/category/path
'/blog{/*}?'</code></pre>
      <p>Dies ist nützlich für:</p>
      <ul>
        <li>Flexible Routing-Strukturen</li>
        <li>Abwärtskompatibilität bei API-Änderungen</li>
        <li>Unterstützung für verschiedene URL-Strukturen</li>
      </ul>

      <h3>Praktische Anwendungsbeispiele</h3>

      <h4>1. Benutzerprofile</h4>
      <pre><code>Basis-Profil
'/user/:id{number}'

Mit optionalem Unterbereich
'/user/:id{number}/(profile|settings|security)?'</code></pre>

      <h4>2. Dateisystem</h4>
      <pre><code>Datei mit optionaler Erweiterung
'/files/:filename{string}.:ext{(jpg|png|pdf)}?'</code></pre>

      <h4>3. API-Endpunkte</h4>
      <pre><code>RESTful API mit Version und Ressource
'/api/v:version{number}/:resource{(users|posts|comments)}/:id{d+}'</code></pre>

      <h3>Tipps und Best Practices</h3>
      <ol>
        <li><strong>Spezifität</strong>: Verwenden Sie so spezifische Constraints wie möglich</li>
        <li><strong>Typsicherheit</strong>: Nutzen Sie Typ-Constraints für bessere Validierung</li>
        <li><strong>Optionale Segmente</strong>: Verwenden Sie <code>?</code> für wirklich optionale Teile</li>
        <li><strong>Gruppierung</strong>: Nutzen Sie Gruppen für zusammengehörige Optionen</li>
        <li><strong>Regex</strong>: Verwenden Sie Regex-Constraints für komplexe Validierungen</li>
      </ol>

      <h3>Fehlerbehandlung</h3>
      <ul>
        <li>Ungültige Patterns werden beim Erstellen eines URLPattern-Objekts geworfen</li>
        <li>Nicht übereinstimmende URLs geben <code>null</code> zurück</li>
        <li>Überprüfen Sie immer die Rückgabewerte der <code>exec()</code>-Methode</li>
      </ul>

      <h3>Weitere Ressourcen</h3>
      <ul>
        <li>
          <a href="https://developer.mozilla.org/de/docs/Web/API/URLPattern" target="_blank"
            >MDN URLPattern Dokumentation</a
          >
        </li>
        <li>
          <a href="https://github.com/kenchris/urlpattern-polyfill" target="_blank">URLPattern Polyfill</a>
        </li>
      </ul>
    </div>
  `;
}
export {
  docs
};
